import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ImportPnrService } from '../Services/import-pnr.service';
import { MessageService } from 'primeng/api';
import { ImportPNREntryProprties } from '../Models/ImportPnrProperties';
import { ActiveSuppliers } from '../Models/ActiveClasses';
import { RevenueManagementService } from '../Services/revenue-management.service';
import { TicketSuppliersAccessCodeProperties} from '../Models/GroupTicketProperties';
import { AirlineMasterProperties } from '../Models/AirlineMasterProperties';
import { AirlineMasterService } from '../Services/airline-master.service';
import { GroupTicketService } from '../Services/groupTicket.service';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { DxDataGridModule } from 'devextreme-angular';
import { DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';

declare var $;
@Component({
    selector: 'app-import-pnr-entry',
    templateUrl: './import-pnr-entry.component.html',
    styleUrls: ['./import-pnr-entry.component.css'],
    imports: [NavMenuComponent, Bind, Toast, Dialog, FormsModule, Select, DxDataGridModule, DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule, DxTemplateModule]
})
export class ImportPnrEntryComponent {
  constructor( private messageservice: MessageService,  private importPnrentryService: ImportPnrService, private revenueService: RevenueManagementService, private airlineservice: AirlineMasterService, private ticketService: GroupTicketService, private groupservice: GroupTicketService) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg' as any
    }
  }
  createairportmodal: boolean = false;
  updateairportmodal: boolean = false;

  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold", "font-size": "15px" });

  };
  modalOptions: NgbModalOptions;
 importPnrEntry = new ImportPNREntryProprties();
  newobj = new ImportPNREntryProprties();
  createobj = new ImportPNREntryProprties();
  supplierList: ActiveSuppliers[] = [];
  
  
  airlineMasterinfo: AirlineMasterProperties[] = [];
  ticketSupplierAccessCodeList: TicketSuppliersAccessCodeProperties[] | undefined;
  officeidListForBind: TicketSuppliersAccessCodeProperties[] = [];
  officeidList: TicketSuppliersAccessCodeProperties[] = [];
  officeid: string = "";
 
/*  accessCodeDisabled: boolean = true;*/

  ngOnInit() {
    this.getDataImportPnrEntryAll();
    this.getSuppliers();
    this.GetAirlineData();

    
    
  }
  getSuppliers() {
    this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((result) => {
      this.supplierList = result;

    });
  }
  GetAirlineData() {
    this.airlineservice.getAirlinesData().subscribe((data) => {
      if (data.length > 0) {

        this.airlineMasterinfo = data;
      }
    })
  }

  GetSupplierAccessCodes = (supplierId: string): void => {
    try {
      this.ticketService.GetTicketAccessCode(supplierId).subscribe(data => {
        this.ticketSupplierAccessCodeList = data;
      /*  this.accessCodeDisabled = false;*/
        console.log(data);
      });
    }
    catch (ex) {
      console.log(ex);
    }
  }
  supplierAdded: boolean = false;
  changeSupplier(supplier) {

    this.officeidListForBind = [];
    this.officeidList = [];
    this.groupservice.GetTicketAccessCode(supplier).subscribe(data => {
      this.officeidListForBind = data;

      let curr = localStorage.getItem("AgencyCurrency");
     

      this.supplierAdded = true;
    });




  }



  popupCreateModel() {
    this.createairportmodal = true;
    

  }
 
  updatepopup(data) {
    this.updateairportmodal = true;
    //console.log(data);
    this.officeid = data.pcc;
   
    this.newobj.importPNREntryID = data.importPNREntryID;
    this.newobj.pcc = data.pcc;
    this.newobj.supplier = data.supplier;
    this.newobj.airline = data.airline;
    this.newobj.entry = data.entry;
    this.changeSupplier(data.supplier);
/*    this.newobj.isDeleted = data.isDeleted;*/
    this.newobj.userId = Number(localStorage.getItem("UserId"));

    
  }

  getDataImportPnrEntryAll() {
    this.importPnrentryService.GetAllImportPnrEntry().subscribe((data) => {


      this.importPnrEntry = data;

    });
  }

  CreateImportPnrEntry() {
    if (this.createobj.supplier == undefined || this.createobj.supplier == "" || this.createobj.supplier == null) {

      document.getElementById("supplierCodeInfoError").innerHTML = '*Required';
      document.getElementById("supplier").style.borderColor = "red";
      document.getElementById("supplier").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("supplierCodeInfoError").innerHTML = '';
      document.getElementById("supplier").style.borderColor = "#ced4da";
      document.getElementById("supplier").style.boxShadow = "";
    }

    if (this.createobj.pcc == undefined || this.createobj.pcc == "" || this.createobj.pcc == null) {

      document.getElementById("pccValid").innerHTML = '*Required';
      document.getElementById("pccId").style.borderColor = "red";
      document.getElementById("pccId").style.boxShadow = "0 0 3px red";

    }
    else {
   /*   document.querySelector("#pccValid").innerHTML = '';*/
      //ele.innerHTML = "";
      document.getElementById("pccValid").innerHTML = '';
      document.getElementById("pccId").style.borderColor = "#ced4da";
      document.getElementById("pccId").style.boxShadow = "";
    }
   
    if (this.createobj.airline == undefined || this.createobj.airline == "" || this.createobj.airline == null) {
      document.getElementById("messageAirline").innerHTML = '*Required';
      document.getElementById("airline").style.borderColor = "red";
      document.getElementById("airline").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messageAirline").innerHTML = '';
      document.getElementById("airline").style.borderColor = "#ced4da";
      document.getElementById("airline").style.boxShadow = "";
    }
    if (this.createobj.entry == undefined || this.createobj.entry == "" || this.createobj.entry == null) {
      document.getElementById("messageEntry").innerHTML = '*Required';
      document.getElementById("entry").style.borderColor = "red";
      document.getElementById("entry").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messageEntry").innerHTML = '';
      document.getElementById("entry").style.borderColor = "#ced4da";
      document.getElementById("entry").style.boxShadow = "";
    }
    //console.log(this.createobj);
    //console.log(this.rateOfExchangeDetails);
    


    if (this.createobj.supplier != undefined && this.createobj.supplier != "" && this.createobj.supplier != null &&
      this.createobj.pcc != undefined && this.createobj.pcc != "" && this.createobj.pcc != null &&
      this.createobj.airline != undefined && this.createobj.airline != "" && this.createobj.airline != null &&
      this.createobj.entry != undefined && this.createobj.entry != "" && this.createobj.entry != null
     
    ) {
      this.newobj.userId = Number(localStorage.getItem("UserId"));
      this.importPnrentryService.CreateImportPnrEntryData(this.createobj).subscribe((data) => {
        this.createairportmodal = false;
        if (data == true) {
          this.getDataImportPnrEntryAll();
          this.createobj = new ImportPNREntryProprties();
          this.messageservice.add({ severity: 'success', summary: 'Successfully', detail: 'Data Saved' });
        }
        else {
          this.messageservice.add({ severity: 'error', summary: 'Fail', detail: 'Data not Saved' });
        }

      })
    }
  }

  UpdateImportPnrEntry() {
    if (this.newobj.supplier == "") {

      document.getElementById("supplierCodeInfoError").innerHTML = '*Required';
      document.getElementById("supplier").style.borderColor = "red";
      document.getElementById("supplier").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("supplierCodeInfoError").innerHTML = '';
      document.getElementById("supplier").style.borderColor = "#ced4da";
      document.getElementById("supplier").style.boxShadow = "";
    }

    if (this.newobj.pcc == "") {

      document.getElementById("messagePcc").innerHTML = '*Required';
      document.getElementById("pcc").style.borderColor = "red";
      document.getElementById("pcc").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messagePcc").innerHTML = '';
      document.getElementById("pcc").style.borderColor = "#ced4da";
      document.getElementById("pcc").style.boxShadow = "";
    }
   
    if (this.newobj.airline == "") {
      document.getElementById("messageAirline").innerHTML = '*Required';
      document.getElementById("airline").style.borderColor = "red";
      document.getElementById("airline").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messageAirline").innerHTML = '';
      document.getElementById("airline").style.borderColor = "#ced4da";
      document.getElementById("airline").style.boxShadow = "";
    }
    if (this.newobj.entry == "") {
      document.getElementById("messageEntry").innerHTML = '*Required';
      document.getElementById("entry").style.borderColor = "red";
      document.getElementById("entry").style.boxShadow = "0 0 3px red";

    }
    else {
      document.getElementById("messageEntry").innerHTML = '';
      document.getElementById("entry").style.borderColor = "#ced4da";
      document.getElementById("entry").style.boxShadow = "";
    }
 /*   console.log(this.createobj);*/

    if (this.newobj.pcc != "" && this.newobj.supplier != "" && this.newobj.airline != "" && this.newobj.entry != ""

    ) {
      this.newobj.userId = Number(localStorage.getItem("UserId"));
      // console.log(this.newobj);
      this.importPnrentryService.UpdateImportPnrEntry(this.newobj).subscribe((data) => {
        this.updateairportmodal = false;
        if (data == true) {
          this.getDataImportPnrEntryAll();
     
          this.messageservice.add({ severity: 'success', summary: 'Successfully', detail: 'Data Updated Successfully' });
        }
        else {
          this.messageservice.add({ severity: 'error', summary: 'Fail', detail: 'Data not Saved' });
        }
        
      })
    }
  }

  DeleteAirport(id, targetmodel, model) {
    //console.log(id);
    this.importPnrentryService.DeleteImportPnrEntryDetails(id, Number(localStorage.getItem("UserId"))).subscribe((data) => {
      if (data == true) {
        this.getDataImportPnrEntryAll();
        this.messageservice.add({ severity: 'success', summary: 'Successfully', detail: 'Data Deleted Successfully' });
      }
      else {
        this.messageservice.add({ severity: 'error', summary: 'Fail', detail: 'Data not Saved' });
      }
    })
  }
}
